import Info_icon from '../../images/Icons/at_info-circle.svg';
import Icon_Code from '../../images/Icons/html.svg';
import Icon_Newspaper from '../../images/Icons/newspaper.svg';
import Icon_Friends from '../../images/Icons/friend.svg';
import Icon_factory from '../../images/Icons/factory.svg';
import Icon_user_frame from '../../images/Icons/user-frame-circle.svg';
import Icon_incognito from '../../images/Icons/incognito.svg';
import Icon_id from '../../images/Icons/identity-card.svg';
import Icon_tcm from '../../images/Icons/icon-tcm.svg';
import tcm_navbar_img from '../../images/product-assets/tcm-navbar-img.png';
import reauth_navbar_img from '../../images/product-assets/reauth-navbar-img.png';

export const NAV_ITEMS = {
    PRODUCTS: 'Products',
    SOLUTIONS: 'Solutions',
    RESOURCES: 'Resources',
    PRICING: 'Pricing',
};

export const DROPDOWN_CATEGORIES = {
    [NAV_ITEMS.PRODUCTS]: {
        IDENTITY: {
            label: 'Identity',
            icon: Icon_user_frame,
        },
        CRIMINAL: {
            label: 'Criminal',
            icon: Icon_incognito,
        },
        BACKGROUND: {
            label: 'Background',
            icon: Icon_id,
        },
        MONITORING: {
            label: 'Monitoring',
            icon: Icon_tcm,
        },
    },
    [NAV_ITEMS.SOLUTIONS]: {
        USE_CASES: { label: 'Use Cases', icon: Icon_Friends },
        INDUSTRIES: {
            label: 'Industries',
            icon: Icon_factory,
        },
    },
    [NAV_ITEMS.RESOURCES]: {
        ABOUT: {
            label: 'About',
            icon: Info_icon,
        },
        DEVELOPERS: { label: 'Developers Hub', icon: Icon_Code },
        WHITEPAPERS: { label: 'Whitepapers', icon: Icon_Newspaper },
    },
};

export const NAV_TAGS = [
    {
        id: 1,
        label: NAV_ITEMS.PRODUCTS,
        value: 'products',
    },
    {
        id: 2,
        label: NAV_ITEMS.SOLUTIONS,
        value: 'solutions',
    },
    {
        id: 3,
        label: NAV_ITEMS.RESOURCES,
        value: 'resources',
    },
    {
        id: 4,
        label: NAV_ITEMS.PRICING,
        value: null,
    },
];

export const IDENTITY_MENU_ITEMS = [
    {
        id: 0,
        label: 'Identity Verification',
        subText: 'Instant Identity Verification and Risk Insights',
        link: '/products/identity',
    },
    {
        id: 1,
        label: 'Document Verification',
        subText: 'Global ID & Document Verification',
        link: '/products/document-verification',
    },
    {
        id: 2,
        label: 'Knowledge Base Authentication',
        subText: 'Dynamic KBA Authentication to Stop Imposters',
        link: '/products/kba',
    },
    // {
    //     id: 3,
    //     label: 'Liveness & Face Match',
    //     subText: 'AI Liveness & Face Match for Spoof‑Proof Signup',
    // },
    // {
    //     id: 4,
    //     label: 'SSN Verification',
    //     subText: 'Instant SSN Verification',
    // },
    // {
    //     id: 5,
    //     label: '2 Factor Authentication',
    //     subText: '2 Factor Authentication using Email & Phone Number',
    // },
    // {
    //     id: 6,
    //     label: 'Risk Score & Insights',
    //     subText: 'Get Confidence and Risk Scores from User PII',
    // },
];

export const CRIMINAL_MENU_ITEMS = [
    {
        id: 0,
        label: 'Criminal Background',
        subText: 'Automated Criminal Records Check',
        link: '/products/criminal-background-checks',
    },
    {
        id: 1,
        label: '7-Year Criminal Activity',
        subText: 'Real Time National Criminal Records Database Search',
        link: '/products/national-criminal-database-search',
    },
    {
        id: 2,
        label: 'Sex Offender Check Pro',
        subText: 'Identify People with a History of Sexual Offences',
        link: '/products/sex-offender-check-pro',
    },
    {
        id: 3,
        label: 'Global Watchlist Check',
        subText: 'International Sanctions & Watchlist Screening',
        link: '/products/global-watchlist-check',
    },
    {
        id: 4,
        label: 'County & Federal Criminal Checks',
        subText: 'County and Federal Criminal & Civil Record Searches ',
        link: '/products/county-and-federal-criminal-check',
    },
];

export const BACKGROUND_MENU_ITEMS = [
    {
        id: 0,
        label: 'Background Verification',
        subText: 'In-depth Background Verifications',
        link: '/products/background-check',
    },
    {
        id: 1,
        label: 'Education',
        subText: 'Verifying educational credentials for accuracy',
        link: '/products/education',
    },
    {
        id: 2,
        label: 'Employment',
        subText: 'Ensure the authenticity of employment details',
        link: '/products/employment',
    },
    // {
    //     id: 3,
    //     label: 'Professional License',
    //     subText: 'Validate credentials for licensed professionals',
    // },
    // {
    //     id: 4,
    //     label: 'DMV-MVR',
    //     subText: 'Ensure the reliability of driving records ',
    // },
];

export const MONITORING_MENU_ITEMS = [
    {
        id: 0,
        label: 'True Continuous Monitoring',
        subText: 'Automates user monitoring to proactively detect and manage new risks',
        img: tcm_navbar_img,
        link: '/products/tcm',
    },
    {
        id: 1,
        label: 'ReAuthenticate',
        subText: 'Free KYC for users with just a selfie! Verify in 30 seconds ',
        img: reauth_navbar_img,
        link: '/products/reauthenticate',
    },
];

export const USE_CASES_MENU_ITEMS = [
    {
        id: 0,
        label: 'Identity Fraud Prevention',
        subText: 'Prevent Identity Fraud in Less than 30 seconds!',
        link: '/solutions/identity-fraud-prevention',
    },
    {
        id: 1,
        label: 'KYC/AML',
        subText: 'Streamlined KYC & Enhanced AML',
        link: '/solutions/kyc-aml-compliance',
    },
    {
        id: 2,
        label: 'Guest Verification',
        subText: 'Greater Security with Precise Guest Screening',
        link: '/solutions/guest-verification',
    },
];

export const INDUSTRIES_MENU_ITEMS = [
    {
        id: 0,
        label: 'Finance',
        subText: 'Instant Onboarding & Screening for Finance',
        link: '/industries/finance',
    },
    {
        id: 1,
        label: 'Marketplace',
        subText: 'Ensure Trust and Safety in E-Commerce',
        link: '/industries/marketplaces',
    },
    {
        id: 2,
        label: 'Healthcare',
        subText: 'Instantly Know Your Patient Solutions',
        link: '/industries/know-your-patient',
    },
];

export const ABOUT_MENU_ITEMS = [
    {
        id: 0,
        label: 'Blogs and Announcements',
        subText: 'Insights on Identity, Security, and Authentication',
        link: '/resources/blog',
    },
    {
        id: 1,
        label: 'Security & Compliance',
        subText: 'Protecting Data with Trusted Security Standards',
        link: '/resources/security-and-compliance',
    },
    // {
    //     id: 2,
    //     label: 'Verification Demo',
    //     subText: 'See Instant, Automated ID Verification in Action — Watch Our Demo Now',
    // },
    // {
    //     id: 3,
    //     label: 'What is Authenticate?',
    //     subText: 'Discover how Authenticate Protects Every Digital Identity End-to-End',
    // },
];

export const DEVELOPERS_MENU = [
    {
        id: 0,
        label: 'API Documentation',
        subText: 'Explore our API Docs to Build and Integrate Fast',
        link: 'https://docs.authenticate.com/',
        external: true,
    },
    // {
    //     id: 1,
    //     label: 'Verification Flow',
    //     subText: 'Step-by-Step Guide to the Verification Process',
    // },
    {
        id: 2,
        label: 'Knowledge Base',
        subText: 'Find Answers Fast with our Comprehensive Knowledge Base for Instant Help',
        link: 'https://info.authenticate.com/',
        external: true,
    },
    // {
    //     id: 3,
    //     label: 'Guides',
    //     subText: 'Comprehensive Step-by-Step Guides to Help You Master Our Products Easily ',
    // },
];

export const WHITEPAPERS_SUBMENU = [
    {
        id: 0,
        label: 'Financial Fraud',
        subText: 'Protect your Business from Financial Fraud Threats',
        link: '/whitepapers/finance',
    },
    {
        id: 1,
        label: 'Healthcare Fraud',
        subText: 'Stop Healthcare Fraud with Secure Authentication',
        link: '/whitepapers/healthcare',
    },
    {
        id: 2,
        label: 'Marketplace Fraud',
        subText: 'Protect Marketplaces Effectively by Preventing Fraud and Fake Users ',
        link: '/whitepapers/marketplace',
    },
];

export const DROPDOWN_MENU_ITEMS = {
    [NAV_ITEMS.PRODUCTS]: {
        [DROPDOWN_CATEGORIES[NAV_ITEMS.PRODUCTS].IDENTITY.label]: IDENTITY_MENU_ITEMS,
        [DROPDOWN_CATEGORIES[NAV_ITEMS.PRODUCTS].CRIMINAL.label]: CRIMINAL_MENU_ITEMS,
        [DROPDOWN_CATEGORIES[NAV_ITEMS.PRODUCTS].BACKGROUND.label]: BACKGROUND_MENU_ITEMS,
        [DROPDOWN_CATEGORIES[NAV_ITEMS.PRODUCTS].MONITORING.label]: MONITORING_MENU_ITEMS,
    },
    [NAV_ITEMS.SOLUTIONS]: {
        [DROPDOWN_CATEGORIES[NAV_ITEMS.SOLUTIONS].USE_CASES.label]: USE_CASES_MENU_ITEMS,
        [DROPDOWN_CATEGORIES[NAV_ITEMS.SOLUTIONS].INDUSTRIES.label]: INDUSTRIES_MENU_ITEMS,
    },
    [NAV_ITEMS.RESOURCES]: {
        [DROPDOWN_CATEGORIES[NAV_ITEMS.RESOURCES].ABOUT.label]: ABOUT_MENU_ITEMS,
        [DROPDOWN_CATEGORIES[NAV_ITEMS.RESOURCES].DEVELOPERS.label]: DEVELOPERS_MENU,
        [DROPDOWN_CATEGORIES[NAV_ITEMS.RESOURCES].WHITEPAPERS.label]: WHITEPAPERS_SUBMENU,
    },
};
